<template>
  <div ref="refTopNav" class="topNav">
    <el-menu :default-active="activeMenuPath"
             mode="horizontal" @select="handleSelect"
             :background-color="theme"
             text-color="#eeeeee"
             active-text-color="#ffffff">
      <template v-for="(item, index) in menuRoutes">
        <!-- index是字符串类型 -->
        <el-menu-item style="text-align: center;"
                      :style="{width: tabWidth + 'px'}"
                      ref="refTabMenu"
                      :index="item.path"
                      :key="index"
                      v-if="index < realVisibleNumber">
          <i :class="item.meta.icon"/>
          <span class="title">{{ item.title }}</span>
        </el-menu-item>
      </template>

      <!-- 顶部菜单超出数量折叠 -->
      <el-submenu index="moreMenu"
                  v-if="menuRoutes.length > realVisibleNumber"
                  style="text-align: center; height: 50px; line-height: 50px"
                  :style="{width: tabWidth + 'px'}">
        <template slot="title">
          <span class="title">更多</span>
        </template>
        <template v-for="(item, index) in menuRoutes">
          <el-menu-item
              :index="item.path"
              :key="index"
              v-if="index >= visibleNumber">
            <i :class="item.meta.icon"/>
            <span class="title">{{ item.title }}</span>
          </el-menu-item>
        </template>
      </el-submenu>
    </el-menu>
  </div>
</template>

<script>

// 初始数
const DEFAULT_INIT_VISIBLE = 20;
export default {
  data() {
    return {
      // 顶部栏数
      realVisibleNumber: DEFAULT_INIT_VISIBLE,
      tabWidth: 100,
      // 是否为首次加载
      isFirst: false,
      // 当前激活菜单的 index
      currentIndex: null
    };
  },
  computed: {
    theme() {
      return this.$store.state.app.theme;
    },

    // 所有的菜单路由信息
    menuRoutes() {
      return this.$store.getters.menuRoutes;
    },
    // 侧边栏是否打开
    sidebarOpen() {
      return this.$store.state.app.sidebar.opened;
    },
    visibleNumber: {
      set(val) {
        this.realVisibleNumber = val;
      },
      get() {
        return this.realVisibleNumber;
      },
    },
    // 默认激活的菜单
    activeMenuPath() {
      let activePath = '/';
      let currPath = this.$route.path;

      // 重定向的本次不处理，比如刷新的时候
      let redirectPath = '/redirect';
      if (currPath && currPath.indexOf(redirectPath) === 0) {
        // currPath = currPath.substring(redirectPath.length, currPath.length);
        return;
      }
      // 如果存在二级path，根据地址，截取第一级路由
      if (currPath.lastIndexOf("/") > 0) {
        let tmpPath = currPath.substring(1, currPath.length);
        activePath = "/" + tmpPath.substring(0, tmpPath.indexOf("/"));
      }
      // 根据地址栏第一级路由，查询路由表，如果存在，则激活，否则地址栏是输入是错误，则获取默认
      let activeRoute = this.activeRoute(activePath);
      // console.log("当前菜单：", activeRoute, currPath, activePath);
      if (!activeRoute) {
        // 不存在，则设置默认第一个
        // activePath = this.defaultRouter();
        // // 重新激活
        // this.activeRoute(activePath);
      }
      return activePath;
    },
  },
  beforeMount() {
    window.addEventListener('resize', this.setVisibleNumber)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.setVisibleNumber)
  },
  mounted() {
    this.setVisibleNumber();
  },
  watch: {
    sidebarOpen: function (val) {
      this.setVisibleNumber();
    }
  },
  methods: {
    setVisibleNumber(e) {
      setTimeout(this._setVisibleNumber, 500);
    },
    /**
     * 根据宽度计算设置显示栏数
     * 这里实际计算navi宽度，和从左到右的每一个li的宽度，然后扣除即可。（暂定不处理）
     */
    _setVisibleNumber() {
      let refNavMenu = this.$parent.$refs['refNavMenu'];
      let refLogo = this.$parent.$refs['refLogo'].$el;
      let refPersonal = this.$parent.$refs['refPersonal'];
      // 获取当前的宽度
      let leftWidth = refNavMenu.offsetWidth - refLogo.offsetWidth - refPersonal.offsetWidth - 10 - 10;
      // 可以保留显示的个数
      let showNum = parseInt(leftWidth / this.tabWidth);
      // console.log("-------showNum--------",refNavMenu.offsetWidth, refLogo.offsetWidth, refPersonal.offsetWidth, showNum);
      let totalCount = this.menuRoutes.length;
      // 是否要显示【更多】
      let showMore = false;
      showMore = totalCount > showNum;
      if (showMore) {
        showNum = showNum - 1;
      } else {
        showNum = totalCount;
      }
      // console.log("_setVisibleNumber", refTopNav.offsetWidth, refPersonal.offsetWidth, showNum)
      this.visibleNumber = showNum;
      // console.log("可以显示tab个数", showNum, totalCount, this.visibleNumber, leftWidth);
    },

    /**
     * 默认激活的TopNav路由
     */
    defaultRouter() {
      let router;
      Object.keys(this.menuRoutes).some((key) => {
        if (!this.menuRoutes[key].meta.hidden) {
          router = this.menuRoutes[key].path;
          return true;
        }
      });
      return router;
    },

    /**
     * 默认激活的子路由
     * @param router 递归节点
     */
    defaultChildrenRouter(router) {
      let retRouter;
      // 没有子路由则返回
      if (!router.children) {
        retRouter = router;
      } else {
        // 默认第0个节点
        retRouter = this.defaultChildrenRouter(router.children[0]);
      }
      return retRouter;
    },

    /**
     * 激活当前路由，比如/redirect/时候就获取不到菜单
     * @param path 地址栏截取下来的一级路由 /sys
     */
    activeRoute(path) {
      let currentRoute = this.menuRoutes.find(item => path === item.path);
      // 设置侧边栏联动菜单，写入到store里面，侧边栏自动监听获取
      if (currentRoute && currentRoute.children && currentRoute.children.length) {
        this.$store.commit("setSidebarMenuRoutes", currentRoute.children);
      } else {
        this.$store.commit("setSidebarMenuRoutes", null);
      }
      return currentRoute;
    },
    /**
     * 菜单选择事件
     * @param index
     */
    handleSelect(index) {
      if (index === this.activeMenuPath) return;
      let path = index;
      let topNavRoute = this.menuRoutes.find(item => path === item.path);
      let routePath = topNavRoute.path;
      if (this.ishttp(routePath)) {
        // http(s):// 路径新窗口打开
        window.open(routePath, "_blank");
      } else if (routePath.indexOf("/redirect") !== -1) {
        // /redirect 路径内部打开
        this.$router.push({path: routePath.replace("/redirect", "")});
      } else {
        // 设置侧边栏联动菜单，写入到store里面，侧边栏自动监听获取
        if (topNavRoute.children && topNavRoute.children.length) {
          this.$store.commit("setSidebarMenuRoutes", topNavRoute.children);

          // 调转到默认的子路由，如果已经有最后一次打开的，则用上次打开的
          let val = this.$store.getters.lastActiveMenuPath[topNavRoute.path];
          let to = {};
          if (val) {
            to.path = val.path;
            to.query = val.query;
          } else {
            let activeMenu = this.defaultChildrenRouter(topNavRoute);
            to = {path: activeMenu.path, query: activeMenu.query}
          }
          this.$router.push(to);
        }
      }
    },

    /**
     * 是否是http直连
     * @param url
     * @returns {boolean}
     */
    ishttp(url) {
      return url.indexOf('http://') !== -1 || url.indexOf('https://') !== -1
    }
  },
};
</script>

<style scoped lang="less">
.topNav {
  height: 100%;

  .title {
    font-size: 16px;
    font-weight: 600;
  }
}

.el-menu .title {
  font-size: 16px;
  font-weight: 600;
}

.el-menu-item {
  padding: 0 18px;
}

.el-menu.el-menu--horizontal {
  border-bottom-width: 0;
}

.el-menu-item.is-active {
  //background-color: #810100!important;
}
:deep(.el-menu--horizontal .el-menu-item),
:deep(.el-menu--horizontal .el-submenu .el-submenu__title){
  height: 50px;
  line-height: 50px;
}

:deep(.el-menu--horizontal .el-submenu .el-submenu__title i) {
  font-size: 16px;
  color: #fff;
}

</style>
